export const SET_INVOICE = 'SET_INVOICE'

export const setInvoice = (invoice) => ({ type: SET_INVOICE, invoice })
